export default "__VITE_ASSET__DP2HmHBW__"